const rows = [
  { feature: "Travel to agency required", fpc: false, agency: true },
  { feature: "Miles from Bismarck to nearest agency", fpc: "0 miles", agency: "650+ miles to Denver" },
  { feature: "Appointment needed", fpc: false, agency: true },
  { feature: "Dedicated agent assigned", fpc: true, agency: false },
  { feature: "Application error review", fpc: true, agency: false },
  { feature: "Daily status updates", fpc: true, agency: false },
  { feature: "Processing in 2–9 days", fpc: true, agency: true },
  { feature: "Available during gov. slowdowns", fpc: true, agency: false },
  { feature: "Money-Back Guarantee", fpc: true, agency: false },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Why Choose Us</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Regional Agency
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            For Bismarck residents, driving to a regional passport agency means a 650+ mile trip to Denver. Here&apos;s why our service is the smarter choice.
          </p>
        </div>

        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Bismarck Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center&apos;s registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="text-left py-4 px-5 text-sm font-semibold text-gray-500 w-1/2">Feature</th>
                <th className="text-center py-4 px-5 text-sm font-bold text-white bg-[#1A365D] rounded-tl-lg">Fast Passport Center</th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-gray-500 bg-[#F7F8FA] rounded-tr-lg">Regional Agency</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-[#F7F8FA]" : "bg-white"}>
                  <td className="py-3.5 px-5 text-sm text-gray-600">{row.feature}</td>
                  <td className="py-3.5 px-5 text-center bg-[#1A365D]/5">
                    {typeof row.fpc === "boolean" ? (
                      row.fpc ? (
                        <i className="ri-check-line text-green-500 text-lg"></i>
                      ) : (
                        <i className="ri-close-line text-green-500 text-lg"></i>
                      )
                    ) : (
                      <span className="text-sm font-semibold text-[#1A365D]">{row.fpc}</span>
                    )}
                  </td>
                  <td className="py-3.5 px-5 text-center">
                    {typeof row.agency === "boolean" ? (
                      row.agency ? (
                        <i className="ri-check-line text-gray-400 text-lg"></i>
                      ) : (
                        <i className="ri-close-line text-red-400 text-lg"></i>
                      )
                    ) : (
                      <span className="text-sm text-gray-500">{row.agency}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            Start My Bismarck Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}